export class DocumentData {
    docName: string;
    docId: number;
    docData: ArrayBuffer;

    constructor(docName: string, docId: number, docData: ArrayBuffer) {
        this.docName = docName;
        this.docId = docId;
        this.docData = docData;
    }
}


